import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { ApiService } from 'src/app/services/api/api.service';
import { TokenService } from 'src/app/services/token/token.service';

@Component({
  selector: 'app-modal-reset-password',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  passwordFormGroup!: FormGroup;

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalComponent>,
    private api: ApiService,
    private route: Router,
    private storage: LocalStorageService,
    @Inject(MAT_DIALOG_DATA) public data: Record<string, unknown>
  ) {}

  ngOnInit(): void {
    this.passwordFormGroup = this.fb.group({
      cpf: [this.data['cpf'], Validators.required],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  resetPassword() {
    if (this.passwordFormGroup.status == 'VALID') {
      //this.token.getToken(this.passwordFormGroup.value.cpf)
      const urlTemp = this.route.url.replace(/^\//, '');
      this.storage.set('urlReturn', urlTemp);
      this.route.navigate(['/cadastro/confirmacao/update']);
      this.onNoClick();

      this.storage.set('CPF', this.passwordFormGroup.value.cpf);
    }
  }

  // btnText="Enviar Token"

  loading = true;

  // save(): void {
  //   this.loading = true;
  //   this.btnText=""
  //   // do your saving thing here
  // }
}
